import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { CustomerEnrollService } from '../customer-enroll.service';
import { LocalStorageService } from 'angular-2-local-storage';
import { FormsModule, FormControl, FormBuilder, Validators, ReactiveFormsModule} from '@angular/forms';
const MOBILE_REGEX = /^\(\d{3}\)\s\d{3}\-\d{4}$/;

@Component({
  selector: 'app-change-phone-number',
  templateUrl: './change-phone-number.component.html',
  styleUrls: ['./change-phone-number.component.css']
})
export class ChangePhoneNumberComponent implements OnInit {
  // variable define
  public mobile_phone_number: string;
  private phone_number: string;
  public username: string;
  public is_change_mobile: boolean;
  public change_mobile: Object;
  public phoneMask = ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  // validate mobile phone number
  mobilePhoneFormControl = new FormControl('', [
  Validators.required,
  Validators.pattern(MOBILE_REGEX)]);
  constructor(private activatedRoute: ActivatedRoute, private sharedService: SharedService,
    private router: Router, private customerEnrollService: CustomerEnrollService,
    private localStorageService: LocalStorageService) {
      this.sharedService.setHeaderTitle('default_page');
      // this.sharedService.setHeaderErrorMessage("change_phone_number", false, "notification error", "");
      if (this.localStorageService.get('token') != null) {
        this.sharedService.verifyToken({'token' : this.localStorageService.get('token')})
        .then(res => {
            if (res.status === 'success' && res.isTerminated === false) {
                // let person = res.results[0]['personal'];
                // this.sharedService.setHeaderUserLoggedIn("change_phone_number", true, person[0]);
            }else {
                this.localStorageService.remove('token');
                this.router.navigate(['./sign-in']);
            }
        });
      }
      const that = this.sharedService;
      this.activatedRoute.params.subscribe((params: Params) => {
                if (params['account_setting'] !== undefined && params['account_setting'] === 'AccountSetting') {
                  setTimeout(function(){
                    that.setHeaderErrorMessage('account_change_phone_number', false, 'notification error', '');
                    that.setHeaderTitle('account_change_phone_number');
                  }, 10);
                }else {
                  setTimeout(function(){
                    that.setHeaderErrorMessage('change_phone_number', false, 'notification error', '');
                    that.setHeaderTitle('change_phone_number');
                  }, 10);
                }
              });
        this.activatedRoute.params.subscribe((params: Params) => {
        this.username = params['username'];
      });
      this.is_change_mobile = false;
   }

  ngOnInit() {
  }

  unmaskData(data:string){
    if (data != null && data.trim()!="") {
      return data.replace(/[\s\(\)\-]/g, '');
    } else {
      return "";
    }
  }

  changeMobileNoValidate(event: any) {
    this.phone_number = this.unmaskData(this.mobile_phone_number);
    if (this.phone_number !== '' && this.phone_number !== undefined && this.mobile_phone_number.match(MOBILE_REGEX)) {
      this.is_change_mobile = true;
      if (event.keyCode === 13) {
        document.getElementById('btn-click').click();
      }
    }else {
      this.is_change_mobile = false;
    }
  }

  // change phone number functionality
  changeMobileNo() {
    if (!this.mobile_phone_number.match(MOBILE_REGEX)) {
        // tslint:disable-next-line:max-line-length
        window.scrollTo(0, 0);
        this.sharedService.setHeaderErrorMessage('change_phone_number', true, 'notification error', 'Please enter valid 10 digit mobile no.');
    }else {
    let acc_setting;
    this.activatedRoute.params.subscribe((params: Params) => {
      if (params['account_setting'] !== undefined && params['account_setting'] === 'AccountSetting') {
        acc_setting = true;
      }else {
        acc_setting = false;
      }
    });
      this.change_mobile = {
        'mobile' : this.phone_number,
        'token' : this.localStorageService.get('token'),
        'acc_setting' : acc_setting
        };
        this.customerEnrollService.changeMobileNo(this.change_mobile).then(res => {
          if (res.status === 'success') {
              this.activatedRoute.params.subscribe((params: Params) => {
                // if (params['account_setting'] !== undefined && params['account_setting'] === 'AccountSetting') {
                //   this.router.navigate(['./Profile/AccountSetting/ChangePhoneNumber/' + res.result.username + '/OtpVerify']);
                // }else {
                //   this.router.navigate(['./otp-verify/' + params['username']]);
                // }
              });

          }else {
              this.activatedRoute.params.subscribe((params: Params) => {
                window.scrollTo(0, 0);
                if (params['account_setting'] !== undefined && params['account_setting'] === 'AccountSetting') {
                  this.sharedService.setHeaderErrorMessage('account_change_phone_number', true, 'notification error', res.result.message);
                }else {
                  this.sharedService.setHeaderErrorMessage('change_phone_number', true, 'notification error', res.result.message);
                }
              });
            }
        });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/customer-enroll/change-phone-number/change-phone-number.component.ts